import $ from 'jquery';

const SELECTORS = {
  AUTOCOMPLETE_SELECT: 'select[data-autocomplete-url]',
};

export default function initializeAutocompletes() {
  const $autocompleteSelects = $(SELECTORS.AUTOCOMPLETE_SELECT);
  applyAutocompletes($autocompleteSelects);
  $(document).on('enquire-form:opened', (event, form) => {
    applyAutocompletes($(form).find(SELECTORS.AUTOCOMPLETE_SELECT));
  });
}

function importSelect2() {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://dvh1deh6tagwk.cloudfront.net/dependencies/js/select2/4.0.3/dist/js/select2.full.min.js';
    script.async = false;
    script.addEventListener('load', resolve);
    script.addEventListener('error', () => reject('Error loading select2 script.'));

    const stylesLink = document.createElement('link');
    stylesLink.rel = 'stylesheet';
    stylesLink.type = 'text/css';
    stylesLink.href = 'https://dvh1deh6tagwk.cloudfront.net/dependencies/js/select2/4.0.3/dist/css/select2.min.css';

    document.head.appendChild(script);
    document.head.appendChild(stylesLink);
  });
}

function applyAutocompletes($selects = [], wrapper) {
  if ($selects.length === 0) {
    return;
  }
  const initializeSelects = () => {
    $selects.each((idx, select) => {
      new Autocomplete(select, wrapper).initialize();
    });
  };
  if (typeof $().select2 !== 'function') {
    importSelect2().then(() => initializeSelects()).catch(console.error);
  } else {
    initializeSelects();
  }
}

class Autocomplete {
  constructor(select) {
    this.$select = $(select);
    this.select2Instance = null;
  }

  initialize() {
    this.defineSelect2Instance();
    this.extendSelect2Instance();
    this.registerEvents();
  }

  defineSelect2Instance() {
    const placeholder = this.$select.attr('data-placeholder') || 'Select an item...';
    this.$select.select2({
      placeholder,
      minimumInputLength: 3,
      allowClear: true,
      selectOnClose: false,
      escapeMarkup: markup => markup,
      dropdownParent: this.$select.parent(),
      width: '100%',
      ajax: {
        delay: 200,
        url: params => this.$select.attr('data-autocomplete-url') + params.term,
        processResults,
      },
    });

    this.select2Instance = this.$select.data('select2');
  }

  extendSelect2Instance() {
    this.select2Instance.$container
      .attr({
        'data-name': this.$select.attr('name'),
        'data-select2-bound': 'true',
      })
      .addClass('luna-input');
  }

  registerEvents() {
    this.select2Instance.on('results:message', function fixDropdownPosition() {
      this.dropdown._resizeDropdown();
      this.dropdown._positionDropdown();
    });

    this.select2Instance.on('open', function allowScrollWhenDropdownIsOpen() {
      this.$dropdown.parents().off(`scroll.select2.${this.id}`);
    });
  }
}

function processResults(data) {
  return {
    results: data.map(({ postcode, suburb, state }) => ({
      text: `${postcode} - ${suburb}`,
      id: `${postcode};${suburb};${state}`,
    })),
    pagination: {
      more: true,
    },
  };
}
